<template>
  <div>
    <v-menu
      bottom
      left
      min-width="100"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          icon
          outlined
          color="primary"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list
        dense
        class="pa-0"
      >
        <!-- <v-list-item
          :disabled="!$store.getters.checkUserPrivilege('ACC_MODIFY_STATUS')"
          @click="enableFeedback(true)"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-thumb-up
            </v-icon>
            Enable/Sync Feedback
            <v-icon
              v-show="store.feedback"
              small
              right
              color="success"
            >
              mdi-check
            </v-icon>
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item
          :disabled="!$store.getters.checkUserPrivilege('ACC_MODIFY_STATUS')"
          @click="enableFeedback(false)"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="error"
            >
              mdi-thumb-down
            </v-icon>
            Disable/Sync Feedback
            <v-icon
              v-show="!store.feedback"
              small
              right
              color="success"
            >
              mdi-check
            </v-icon>
          </v-list-item-title>
        </v-list-item>
        <v-divider />-->
        
        <v-list-item
          :disabled="!$store.getters.checkUserPrivilege('STORE_SETUP')"
          @click="unlinkPosServer()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="error"
            >
              mdi-link-off
            </v-icon>
            Unlink Pos Server
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="store.whatsapp && store.whatsapp.org_id"
          :disabled="!$store.getters.checkUserPrivilege('STORE_SETUP')"
          @click="deleteWhatsappGroup()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="error"
            >
              mdi-close
            </v-icon>
            Remove Whatsapp Group
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { failure } from "@/mixins/common";

export default {
  name: "AccountOptions",
  components: {
  },
  mixins: [failure],
  props: {
    store: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      link: false
    };
  },
  methods: {
    enableFeedback(status) {
      let msg,
        url = `${this.ADMIN_API_URL}/accounts/${this.store.accountId}/stores/${this.store.id}/feedbacks`;
      if (status) {
        msg = "Are you sure you want to enable feedback?";
        url += "/enable";
      } else {
        msg = "Are you sure you want to disable feedback?";
        url += "/disable";
      }
      this.$root.$confirm.open("Confirm", msg, {}).then((confirm) => {
        if (!confirm) {
          return;
        }
        this.$http.put(url).then(
          (data) => {
            this.handleSuccess(data.body);
          },
          (failure) => {
            this.handleFailure(failure);
          }
        );
      });
    },
    unlinkPosServer() {
      this.$root.$confirm
        .open("Confirm", `Are you sure you to unlink "${this.store.name}"?`, {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http.put(`${this.ADMIN_API_URL}/stores/${this.store.id}/unlinkPosServers`).then(
            function (data) {
              this.handleSuccess(data.body);
            },
            function (failure) {
              this.handleFailure(failure);
            }
          );
        });
    },
    deleteWhatsappGroup(){
      this.$root.$confirm
        .open("Confirm", `Are you sure you want to delete whatsappgroup for this store "${this.store.name}"?`, {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http.put(`${this.ADMIN_API_URL}/stores/${this.store.id}/removeWhatsappGroup`).then(
            function (data) {
              this.handleSuccess(data.body);
            },
            function (failure) {
              this.handleFailure(failure);
            }
          );
        });

    },
    handleSuccess(response) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
      this.$emit("reload");
    }
  }
};
</script>
